import {DashboardMenuOption} from 'components/dashboard-menu/component'
import {PanelBarOption} from 'components/panel-bar/types'
import React from 'react'
import {WidgetsComponent} from './component'
import {allSections} from './constants'

export const routes = allSections.map( (item: PanelBarOption) => (
  {
    action: () => <WidgetsComponent selectedItem={item}  />,
    path: DashboardMenuOption.widgets + (item.route.length === 0 ? '' : '/' + item.route),
  }
));
